import { createSlice } from '@reduxjs/toolkit';
import { resetStore } from '../../Actions';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
// import { fireApi } from 'src/utils/FireApi';
import { AccessLevelApi, globalApi } from '../../../utils/Apis';

const initialState = {
  state_data: null,
  city_data: null,
  loan_type_data: null,
  band_drop_data: null,
  branch_data: null,
  source_data: null,
  config_data: null,
  manager_data: null,
  status_data: null,
  emp_master_list: null,
  master_type: null,
  user_list: null,
  partner_status: null,
  docs_type: null,
  partner_company: null,
  partner_status_company: null,
  master_loan_types: null,
  parent_loan_master: null,
  company_loan_master: null,
  parent_emp_types: null,
  emp_types: null,
  access_level_data: null,
  department_list: null,
  signUpDocsType: null,
  signUpCreatePartnerList: null,
  bank_dropdown_data: null
};

const GlobalSlice = createSlice({
  name: 'GlobalSlice',
  initialState,
  reducers: {
    setStateData(state, action) {
      state.state_data = action.payload;
    },
    setCityData(state, action) {
      state.city_data = action.payload;
    },
    setLoanType(state, action) {
      state.loan_type_data = action.payload;
    },
    setBankDropdown(state, action) {
      state.band_drop_data = action.payload;
    },
    setBankDropdown2(state, action) {
      state.bank_dropdown_data = action.payload;
    },
    setBranchDetails(state, action) {
      state.branch_data = action.payload;
    },
    setSourceData(state, action) {
      state.source_data = action.payload;
    },
    setAccessConfig(state, action) {
      state.config_data = action.payload;
    },
    setInternalManager(state, action) {
      state.manager_data = action.payload;
    },
    setStatusData(state, action) {
      state.status_data = action.payload;
    },
    setEmpMaster(state, action) {
      state.emp_master_list = action.payload;
    },
    setMasterList(state, action) {
      state.master_type = action.payload;
    },
    setUserList(state, action) {
      state.user_list = action.payload;
    },
    setPartnerStatus(state, action) {
      state.partner_status = action.payload;
    },
    setDocsType(state, action) {
      state.docs_type = action.payload;
    },
    setPartnerCompany(state, action) {
      state.partner_company = action.payload;
    },
    setPartnerCompanyStatus(state, action) {
      state.partner_status_company = action.payload;
    },
    setMasterLoanType(state, action) {
      state.master_loan_types = action.payload;
    },
    setParnerLoanMaster(state, action) {
      state.parent_loan_master = action.payload;
    },
    setCompanyLoanMasters(state, action) {
      state.company_loan_master = action.payload;
    },
    setParentEmpTypes(state, action) {
      state.parent_emp_types = action.payload;
    },
    setEmpTypesList(state, action) {
      state.emp_types = action.payload;
    },
    setAccessLevelData(state, action) {
      state.access_level_data = action.payload;
    },
    setDepartmentList(state, action) {
      state.department_list = action.payload;
    },
    setSignUpDocsType(state, action) {
      state.signUpDocsType = action.payload;
    },
    setSignUpCreatePatner(state, action) {
      state.signUpCreatePartnerList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// State Data
export const getStateData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.stateList,
      method: 'post',
      payload: data,
      skipAuth: true
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setStateData(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setStateData(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ State Data failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 State Data exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// City Data
export const getCityData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.cityList,
      method: 'post',
      payload: data,
      skipAuth: true
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCityData(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCityData(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ City Data failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 City Data exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// get document type Data
export const getSignUpDocumentTypeData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.documentTypes,
      method: 'get',
      payload: data,
      skipAuth: true
    });
    // console.log('getDocumentTypeData res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setSignUpDocsType(res?.data?.data ? res?.data?.data?.documentTypes : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setSignUpDocsType(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ documentTypes failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 documentTypes exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// get create partner
export const getSignUpCreatePartnerData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.createPartner,
      method: 'post',
      payload: data,
      skipAuth: true
    });
    // console.log('getSignUpCreatePartnerData res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setSignUpCreatePatner(res?.data?.data ? res?.data?.data?.documentTypes : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setSignUpCreatePatner(null)); // store in redux
      dispatch(setApiError(res?.description || res?.msg || 'Create partner failed'));
      console.error('❌create partner failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Network error, please try again'));
    console.error('🔥 create partner exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Loan Type
export const getLoanTypeData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.loanType,
      method: 'post',
      payload: data
    });
    // console.log('in loan type', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setLoanType(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setLoanType(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Loan Type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Loan Type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Bank Dropdown
export const getBankDropdownData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.bandDropApi,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setBankDropdown(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setBankDropdown(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Bank Dropdown failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Bank Dropdown exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// bank 2 dropdown
export const getBankDropdownData2 = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.bankList,
      method: 'get',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setBankDropdown2(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setBankDropdown2(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Bank Dropdown failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Bank Dropdown exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Bank Branch Details
export const getBankBranchData = (branchId) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.bankBranchList(branchId)
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setBranchDetails(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setBranchDetails(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Bank Branch Details failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Bank Branch Details exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Source List
export const getSourceListData = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.sourceList
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setSourceData(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setSourceData(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Source List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Source List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Access Level Config data
export const getAccessLevelConfig = (data, token) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AccessLevelApi?.accessLevel,
      method: 'post',
      payload: data,
      extraHeaders: token ? { Authorization: `Bearer ${token}` } : {}
    });
    // console.log('sss Access Level Config data res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAccessConfig(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAccessConfig(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌Access Level Config data failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥Access Level Config data exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Internal Sales Manager
export const getInternalSaleManager = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.internalSaleManagerList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setInternalManager(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setInternalManager(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Internal Sales Manager failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Internal Sales Manager exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Status List
export const getStatusList = (id) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.statusList(id)
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setStatusData(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setStatusData(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Status List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Status List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// All Employee Master list
export const getAllEmpMasterList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.allEmpMasterList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setEmpMaster(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setEmpMaster(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ All Employee Master list failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 All Employee Master list exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Master list type
export const getMasterListType = (type) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.masterListType(type)
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setMasterList(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setMasterList(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌Master list type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥Master list type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// User List
export const getUsersList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.usersList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setUserList(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setUserList(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ User List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 User List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Partner status
export const getPartnerTypesData = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.partnerTypes
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setPartnerStatus(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setPartnerStatus(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Partner status failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Partner status exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Document type
export const getDocsTypesData = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.docsTypes
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setDocsType(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setDocsType(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Document type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Document type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Partner Company type
export const getPartnerCompanyType = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.partnerCompanyTypes
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setPartnerCompany(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setPartnerCompany(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Partner Company type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Partner Company type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Partner Status type
export const getPartnerStatusType = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.partnerStatusTypes
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setPartnerCompanyStatus(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setPartnerCompanyStatus(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Partner Status type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Partner Status type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Partner Status type
export const getMasterLoanTypes = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.masterLoanTypes
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setMasterLoanType(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setMasterLoanType(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Partner Status type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Partner Status type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Partner Loan Masters
export const getPartnerLoanMasters = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.partnerLoanMasters,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setParnerLoanMaster(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setParnerLoanMaster(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Partner Loan Masters failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Partner Loan Masters exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// get Company Loan Masters
export const getCompanyLoanMasters = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.companyLoanMasters,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCompanyLoanMasters(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCompanyLoanMasters(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ get Company Loan Masters failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 get Company Loan Masters exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// get Parent Emp Types
export const getParentEmpTypes = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.parentEmpTypes,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setParentEmpTypes(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setParentEmpTypes(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ get Parent Emp Types failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 get Parent Emp Types exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// get Emp Types List
export const getEmpTypesList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: globalApi?.empTypesList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setEmpTypesList(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setEmpTypesList(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ get Emp Types List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 get Emp Types List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// get Emp Types List
export const getAccessLevelData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${globalApi?.accessLevelList}${data}`,
      method: 'get',
      payload: data
    });
    console.log('sss get Access Level Data res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAccessLevelData(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAccessLevelData(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ get Access Level Data failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 get Access Level Data exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Save API
export const saveApiData = (endpoint, data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: endpoint,
      method: 'post',
      payload: data
    });
    console.log('sss saveApiData res111', res);
    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || res?.error || 'Something went wrong'));
      console.error('❌ Save API failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Save API exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const downloadApiData = (endpoint, data) => async (dispatch) => {
  console.log('downloadApiData called with endpoint:', endpoint, 'and data:', data);
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: endpoint,
      method: 'post',
      payload: data,
      config: {
        responseType: 'blob'
      }
    });
    // console.log('sss downloadApiData res111', res);
    console.log(res.data instanceof Blob); // true
    // 🔹 Handle success
    if (res?.success || res?.data instanceof Blob) {
      return res;
    } else {
      console.log('in else', res);
      dispatch(setApiError(res?.message || res?.error || 'Something went wrong'));
      console.error('❌ Save API failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Save API exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};
export const downloadApiDataGet = (endpoint, data) => async (dispatch) => {
  // console.log('downloadApiData called with endpoint:', endpoint, 'and data:', data);
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: endpoint,
      method: 'get',
      payload: data,
      config: {
        responseType: 'blob'
      }
    });
    // console.log('sss downloadApiData res111', res);
    // console.log(res.data instanceof Blob); // true
    // 🔹 Handle success
    if (res?.success) {
      return res;
    } else {
      dispatch(setApiError(res?.message || res?.error || 'Something went wrong'));
      console.error('❌ Save API failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Save API exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const savefileApiData = (endpoint, data, token) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const extraHeaders = {
      'Content-Type': 'multipart/form-data'
    };
    if (token) {
      extraHeaders.Authorization = `Bearer ${token}`;
    }

    const res = await fireApi({
      endpoint,
      method: 'post',
      payload: data,
      extraHeaders
    });

    if (res?.success) {
      dispatch(setApiError('Data uploaded successfully !'));
      return res;
    } else {
      dispatch(setApiError(res?.message || res?.error || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const checkDataApi = (endpoint, data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: endpoint,
      method: 'get',
      payload: data
    });
    console.log('sss checkDataApi res', res);
    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.description || 'Something went wrong222'));
      console.error('❌ checkDataApi API failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError(error?.description || 'testing wrong'));
    console.error('🔥 Save API exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const PreviewImageApi =
  (endpoint, data, isBlob = false) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));

    try {
      const res = await fireApi({
        endpoint: endpoint,
        method: 'get',
        payload: data,

        // ✅ PASS INSIDE config
        config: {
          responseType: isBlob ? 'blob' : 'json'
        }
      });

      // console.log('PreviewImageApi res', res);

      // ✅ Blob response
      if (isBlob) {
        let actualBlob = res?.data;
        if (actualBlob instanceof Blob && actualBlob.size >= 4) {
          try {
            const buffer = await actualBlob.slice(0, 4).arrayBuffer();
            const view = new DataView(buffer);
            const magic = view.getUint32(0, false);
            let realType = actualBlob.type;

            if (magic === 0x25504446) realType = 'application/pdf';
            else if ((magic && 0xffffff00) === 0xffd8ff00) realType = 'image/jpeg';
            else if (magic === 0x89504e47) realType = 'image/png';
            else if (magic === 0x47494638) realType = 'image/gif';

            if (realType && realType !== actualBlob.type) {
              actualBlob = new Blob([actualBlob], { type: realType });
            }
          } catch (e) {
            console.warn('Failed to detect true blob type', e);
          }
        }
        return actualBlob; // 👈 return Blob only
      }

      // ✅ JSON response
      if (res?.success) {
        return res?.data;
      } else {
        dispatch(setApiError(res?.description || 'Something went wrong'));
        return null;
      }
    } catch (error) {
      dispatch(setApiError(error?.description || 'API exception'));
      console.error('🔥 API exception ', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

export const deleteRowApi = (endpoint, data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: endpoint,
      method: 'post',
      payload: data
    });
    // console.log('sss delete api res', res);
    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.error || 'Something went wrong222'));
      console.error('❌ checkDataApi API failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError(error?.description || 'testing wrong'));
    console.error('🔥 Save API exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// department list
export const getDepartmentList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${globalApi?.departmentList}/${data?.companyId}`
    });
    console.log('sss department list res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setDepartmentList(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setDepartmentList(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Partner Company type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Partner Company type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const {
  setStateData,
  setCityData,
  setLoanType,
  setBankDropdown,
  setBranchDetails,
  setSourceData,
  setAccessConfig,
  setInternalManager,
  setStatusData,
  setEmpMaster,
  setMasterList,
  setUserList,
  setPartnerStatus,
  setDocsType,
  setPartnerCompany,
  setPartnerCompanyStatus,
  setMasterLoanType,
  setParnerLoanMaster,
  setCompanyLoanMasters,
  setParentEmpTypes,
  setEmpTypesList,
  setAccessLevelData,
  setDepartmentList,
  setSignUpDocsType,
  setSignUpCreatePatner,
  setBankDropdown2
} = GlobalSlice.actions;
export default GlobalSlice.reducer;
